import { defineComponent as h, ref as k, computed as o, resolveComponent as g, openBlock as s, createElementBlock as f, normalizeClass as l, createBlock as y, mergeProps as p, createCommentVNode as S } from "vue";
import { O as b, I as u, a as i } from "./OrIcon-k8cyvh-D.mjs";
import { _ as w } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var e = /* @__PURE__ */ ((r) => (r.Success = "success", r.Neutral = "neutral", r.Warning = "warning", r.Outline = "outline", r.Error = "error", r.Inherit = "inherit", r))(e || {}), n = /* @__PURE__ */ ((r) => (r.XL = "xl", r.L = "l", r.M = "m", r.S = "s", r))(n || {});
const O = {
  [n.XL]: [
    // Layout
    "shrink-0",
    // Box
    "w-[24px]",
    "h-[24px]",
    // Shape
    "rounded-full"
  ],
  [n.L]: [
    // Layout
    "shrink-0",
    // Box
    "w-[20px]",
    "h-[20px]",
    // Shape
    "rounded-full"
  ],
  [n.M]: [
    // Layout
    "shrink-0",
    // Box
    "w-[16px]",
    "h-[16px]",
    // Shape
    "rounded-full"
  ],
  [n.S]: [
    // Layout
    "shrink-0",
    // Box
    "w-[8px]",
    "h-[8px]",
    // Shape
    "rounded-full"
  ]
}, I = {
  [e.Error]: [
    "theme-foreground-on-error",
    "dark:theme-foreground-on-error-dark",
    "theme-background-error",
    "dark:theme-background-error-dark"
  ],
  [e.Neutral]: [
    "theme-foreground-on-primary",
    "dark:theme-foreground-on-primary-dark",
    "theme-background-primary",
    "dark:theme-background-primary-dark"
  ],
  [e.Inherit]: [],
  [e.Outline]: [
    "theme-foreground-on-secondary",
    "dark:theme-foreground-on-secondary-dark",
    "theme-background-secondary",
    "dark:theme-background-secondary-dark"
  ],
  [e.Success]: [
    "theme-foreground-on-success",
    "dark:theme-foreground-on-success-dark",
    "theme-background-success",
    "dark:theme-background-success-dark"
  ],
  [e.Warning]: [
    "theme-foreground-on-warning",
    "dark:theme-foreground-on-warning-dark",
    "theme-background-warning",
    "dark:theme-background-warning-dark"
  ]
}, v = {
  [e.Error]: [
    "theme-foreground-error",
    "dark:theme-foreground-error-dark"
  ],
  [e.Neutral]: [
    "theme-foreground-primary",
    "dark:theme-foreground-primary-dark"
  ],
  [e.Inherit]: [],
  [e.Outline]: [
    "theme-foreground-secondary",
    "dark:theme-foreground-secondary-dark"
  ],
  [e.Success]: [
    "theme-foreground-success",
    "dark:theme-foreground-success-dark"
  ],
  [e.Warning]: [
    "theme-foreground-warning",
    "dark:theme-foreground-warning-dark"
  ]
}, x = h({
  name: "OrIndicator",
  components: {
    OrIcon: b
  },
  props: {
    size: {
      type: String,
      default: () => n.M
    },
    color: {
      type: String,
      default: e.Neutral
    },
    icon: {
      type: [String, Object, void 0],
      default: void 0
    }
  },
  setup(r) {
    const a = k(), t = o(() => [
      "or-indicator-v3",
      ...r.icon ? [] : O[r.size],
      ...r.icon ? [] : I[r.color]
    ]), d = o(() => [
      ...v[r.color]
    ]), c = o(() => typeof r.icon == "string" ? {
      icon: r.icon,
      variant: u.Inherit,
      size: r.size === n.S ? i.M : r.size
    } : {
      variant: u.Inherit,
      size: r.size === n.S ? i.M : r.size,
      ...r.icon
    });
    return {
      iconContainerStyles: d,
      iconProps: c,
      root: a,
      rootStyles: t
    };
  }
});
function z(r, a, t, d, c, _) {
  const m = g("OrIcon");
  return s(), f("div", {
    ref: "root",
    class: l(r.rootStyles)
  }, [
    r.icon ? (s(), y(m, p({
      key: 0,
      class: r.iconContainerStyles
    }, r.iconProps), null, 16, ["class"])) : S("", !0)
  ], 2);
}
const L = /* @__PURE__ */ w(x, [["render", z]]);
export {
  e as I,
  L as O,
  n as a
};
//# sourceMappingURL=OrIndicator-CCrOseW7.mjs.map
